// TRIGGERS

$( document ).ready(function() {
  let variantInitials = $('select.product-single__variants[name="id"]').val();
  let initials = $('#all-variant-options').find(`span.variant-option[data-variant-id="${variantInitials}"]`).attr('data-option-2');
  let NoInitials = $('#all-variant-options').find(`span.variant-option[data-variant-id="${variantInitials}"]`).attr('data-option-3');
  let $price = $('span.product__price[data-product-price]').text();
  hideNoInitials(initials,NoInitials,$price);

  function formatState(state) {
    if (!state.id) {
      return state.text;
    }
    var $state = $(state.element).data('html');
    return $($state);
  }

  $('.build-set__variants--dropdown--select').select2({
    templateResult: formatState,
    templateSelection: formatState,
    escapeMarkup: function(markup) {
      return markup;
    },
    minimumResultsForSearch: Infinity
  });

});

document.addEventListener('variant:change', function(evt) {
  let initials = evt.detail.variant.option2;
  let NoInitials = evt.detail.variant.option3;
  let price = evt.detail.variant.price;
  let priceFormatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(price / 100);
  hideNoInitials(initials,NoInitials,priceFormatted);
});

$('#container-buttons button').click(function() {
  addToCartLetters();
});



// FUNCTIONS  

function hideNoInitials(x, y, z) {
  let $noInitials = $('.variant-wrapper[data-option="3"]');
  let $container = $('.build-set__variants.build-set__variants--dropdown');

  if (x === 'None') {
    $noInitials.hide();
  } else {
    $noInitials.show();
  }

  $('div#selector-initials .initials .build-set__variants--dropdown__items').removeClass('initials-item--active');

  if (y > 0) {
    $container.addClass('has-active-items');
  } else {
    $container.removeClass('has-active-items');
  }
  
  for (let i = 1; i <= y; i++) {
    $('div#selector-initials .initials .build-set__variants--dropdown__items[data-select="' + i + '"]').addClass('initials-item--active');
  }

  $('#container-buttons #total-customization b').text(z);
  
}


function addToCartLetters(){
    let $button = $('#container-buttons button');
    $button.addClass('btn--loading');
    let variantSelect = $('select[name="id"]').val();
    let productosData = [];
    let properties = {};
    let lettersSelect = $('#container-initials-function .initials-item--active');
    $(lettersSelect).each(function(index) {
      let initial = (index + 1) + "th";
      if (index === 0) {
        initial = (index + 1) + "st";
      } else if (index === 1) {
        initial = (index + 1) + "nd";
      } else if (index === 2) {
        initial = (index + 1) + "rd";
      }
      let property =  initial + " initial";
      let value = $(this).find('select').val();
      properties[property] = value;
    });
    var product = {
      id: variantSelect,
      quantity: 1,
      properties: properties
    };
    productosData.push(product);
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          items: productosData
        },
        dataType: 'json',
        success: function() {
          console.log('Productos añadidos al carrito');
          $button.removeClass('btn--loading');
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          console.log('Error al agregar los productos al carrito');
          $button.removeClass('btn--loading');
        }
    });
  };